import { Banknote, FileOutput, Lock, TrendingUp } from 'lucide-react';

import { formatarDinheiro } from '@/nucleo/dinheiro';

import { CartaoIndicador } from './CartaoIndicador';
import type { CicloConsolidado } from './tipos';

/** Seção "Ciclo financeiro consolidado" — competências e valores movimentados no período. */
export function CicloFinanceiroConsolidado({ dados }: { dados: CicloConsolidado }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      <CartaoIndicador
        titulo="Valor fechado"
        valor={formatarDinheiro(dados.valorFechado)}
        descricao={`${dados.fechamentosFechados} de ${dados.fechamentosTotal} competências`}
        icone={Lock}
        tom="positivo"
        to="/operacao/financeiro/selamento-mensal"
      />
      <CartaoIndicador
        titulo="Distribuído"
        valor={formatarDinheiro(dados.valorDistribuido)}
        descricao={`${dados.demonstrativosDistribuidos} demonstrativos`}
        icone={FileOutput}
        to="/operacao/financeiro/demonstrativos"
      />
      <CartaoIndicador
        titulo="Em lotes SOF"
        valor={formatarDinheiro(dados.valorEmLotes)}
        descricao={`${dados.lotesConfirmados}/${dados.lotesTotal} confirmados`}
        icone={Banknote}
        to="/operacao/financeiro/sof"
      />
      <CartaoIndicador
        titulo="Fechamentos abertos"
        valor={dados.fechamentosAbertos}
        descricao="Aguardando consolidação"
        icone={TrendingUp}
        tom={dados.fechamentosAbertos > 0 ? 'atencao' : 'neutro'}
        to="/operacao/financeiro/selamento-mensal"
      />
    </div>
  );
}
